// extracted by mini-css-extract-plugin
export default {"container":"OJ2mtXxHxT3qRsE6qobQ","in":"GF8zun6qxlzOhWDkLJ9v","content":"lYl1wFgmwH6MtFrTuVfo","reactions":"GdPycj2qbNFpVoxnFmEw","totalAmount":"AL78J0ZutSj9wWxXI4pW"};